import { render, staticRenderFns } from "./StroeIssueRecords.vue?vue&type=template&id=1f3339a2&"
import script from "./StroeIssueRecords.vue?vue&type=script&lang=js&"
export * from "./StroeIssueRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports